<template>
  <div>
    <div class="m--lg">
      <div>Buttons</div>
      <hr />

      <dara-row class="my--lg">
        <dara-button>Default</dara-button>
        <dara-button theme="primary">Primary</dara-button>
        <dara-button theme="success">Success</dara-button>
        <dara-button theme="info">Info</dara-button>
        <dara-button theme="warning">Warning</dara-button>
        <dara-button theme="danger">Danger</dara-button>
      </dara-row>

      <dara-row class="my--lg">
        <dara-button disabled>Default</dara-button>
        <dara-button theme="primary" disabled>Primary</dara-button>
        <dara-button theme="success" disabled>Success</dara-button>
        <dara-button theme="info" disabled>Info</dara-button>
        <dara-button theme="warning" disabled>Warning</dara-button>
        <dara-button theme="danger" disabled>Danger</dara-button>
      </dara-row>

      <dara-row class="mb--lg">
        <dara-button plain>Default</dara-button>
        <dara-button theme="primary" plain>Primary</dara-button>
        <dara-button theme="success" plain>Success</dara-button>
        <dara-button theme="info" plain>Info</dara-button>
        <dara-button theme="warning" plain>Warning</dara-button>
        <dara-button theme="danger" plain>Danger</dara-button>
      </dara-row>

      <dara-row class="mb--lg">
        <dara-button plain disabled>Default</dara-button>
        <dara-button theme="primary" plain disabled>Primary</dara-button>
        <dara-button theme="success" plain disabled>Success</dara-button>
        <dara-button theme="info" plain disabled>Info</dara-button>
        <dara-button theme="warning" plain disabled>Warning</dara-button>
        <dara-button theme="danger" plain disabled>Danger</dara-button>
      </dara-row>

      <dara-row class="mb--lg">
        <dara-button icon="search"></dara-button>
        <dara-button theme="primary" icon="pencil"></dara-button>
        <dara-button theme="success" icon="check-lg"></dara-button>
        <dara-button theme="info" icon="book"></dara-button>
        <dara-button theme="warning" icon="chat"></dara-button>
        <dara-button theme="danger" icon="eraser"></dara-button>
      </dara-row>
    </div>
    <div class="m--lg">
      <div>Header</div>
      <hr />

      <dara-row class="my--lg">
        <dara-header size="sm">Meu título</dara-header>
        <dara-header size="md">Meu título</dara-header>
        <dara-header size="lg">Meu título</dara-header>
      </dara-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DashboardPage',
};
</script>
